import apiSettings from '@/api/settings'

const faviconElement = document.getElementById('favicon')

const state = {
  appName: localStorage.getItem('app_name') ? localStorage.getItem('app_name') : process.env.VUE_APP_TITLE,
  favicon: localStorage.getItem('favicon'),
  faviconDot: localStorage.getItem('favicon_dot'),
  loginBgColor: localStorage.getItem('login_bg_color') === null ? 'white' : localStorage.getItem('login_bg_color'),
  logoImg: localStorage.getItem('logo_img') === null ? 'https://via.placeholder.com/110x18' : localStorage.getItem('logo_img'),
  collapsedLogoImg: localStorage.getItem('collapsed_logo_img') === null ? 'https://via.placeholder.com/110x18' : localStorage.getItem('collapsed_logo_img'),
  logoHomeImg: localStorage.getItem('logo_home_img') === null ? 'https://via.placeholder.com/110x18' : localStorage.getItem('logo_home_img'),
  logoLumbreDocs: localStorage.getItem('logo_lumbredocs') === null ? 'https://via.placeholder.com/110x18' : localStorage.getItem('logo_lumbredocs'),
  logoLumileWhite: localStorage.getItem('logo_lumile_white') === null ? 'https://via.placeholder.com/110x18' : localStorage.getItem('logo_lumile_white'),
  loginH1Text: '',
  title1: localStorage.getItem('title1'),
  title2: localStorage.getItem('title2'),
  text: localStorage.getItem('text'),
  bgImage: localStorage.getItem('bg_image'),
  menuBgColor: '#727cf5',
  menuFontColor: '#cedce4',
  menuActiveFontColor: '#fff',
  logoAlignItems: 'center',
  logoJustifyContent: 'center',
  logoWidth: '100%',
  logoPadding: '17px 32px 35px 32px',
  loginLogoWidth: '50%',
  loginLogoJustifyContent: 'flex-start',
  loginTextAlign: 'left',
  dashItems: [],
  loading: false,
  // LmList.vue component dynamic settings
  listTitle: '',
  order: [],
  orderBySetting: [],
  searchOnFields: [],
  perPageSetting: [5, 10, 15, 20, 50],
  defaultItemsPerPage: 10,
  limitExportFromClient: 10000,
  showFilterTime: false,
  showGoBackButton: false,
  highlightSearchMatches: false,
  showPDFButton: false,
  showCSVButton: true,
  lmListActions: [],
  hideSearchSection: false,
  hideBreadcrumb: false,
  downloadCsvFileName: 'download',
  apiCallPath: '',
  highlight: {},
  actions: [],
  mainMenuItems: [],
  createSegment: {},
  showLmDropdownTableCustom: true,
  customerList: [],
  googleMapsApiKey: null,
  appUsageTerms: {},
  wacom: {
    encryptionPublicKey: null,
    sdkApiKey: null
  }
}

const getters = {
  appName (state) {
    return state.appName
  },
  accentColor (state) {
    return state.menuBgColor
  },
  googleMapsApiKey (state) {
    return state.googleMapsApiKey
  },
  wacom (state) {
    return state.wacom
  },
  menuItems (state) {
    return state.mainMenuItems.filter(el => el?.id !== 'configuracion')
  },
  settingsItem (state) {
    return state.mainMenuItems.find(el => el?.id === 'configuracion') || null
  }
}

const actions = {
  async getCustomerSettings ({ commit }) {
    try {
      const response = await apiSettings.getCustomerSettings('mysettings/formbuilder,customization,wacom')
      commit('customerSettings', response)
    } catch (error) {
      console.log(error)
    }
  },
  getCoreSettings ({ commit }) {
    return apiSettings.getCoreSettings()
      .then(response => {
        commit('coreSettings', response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getHomeSettings ({ commit }) {
    return apiSettings.getHomeSettings()
      .then(response => {
        commit('homeSettings', response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDashSettings ({ commit }) {
    commit('mutateLoading', true)
    return apiSettings.getDashSettings()
      .then(response => {
        commit('dashSettings', response)
        return response
      })
      .catch(error => {
        throw error
      })
  },
  getListSettings ({ commit }, destinationUri) {
    commit('mutateLoading', true)
    commit('resetStates')
    return apiSettings.getListSettings(destinationUri)
      .then(response => {
        commit('listSettings', response)
        commit('mutateLoading', false)
        return response
      })
      .catch(error => {
        console.log(error)
        commit('mutateLoading', false)
      })
  },
  geAddOrEditSettings ({ commit }, destinationUri) {
    commit('mutateLoading', true)
    return apiSettings.geAddOrEditSettings(destinationUri)
      .then(response => {
        commit('mutateLoading', false)
        // Por  https://github.com/lumile/lumbre/issues/289
        // Se setea el loading también para commons.
        commit('commons/mutateLoading', false, { root: true })
        return response
      })
      .catch(error => {
        console.log(error)
      })
  },
  getMainMenuSettings ({ commit }) {
    return apiSettings.getMainMenuSettings()
      .then(response => {
        commit('mutateMainMenuSettings', response)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

const mutations = {
  customerSettings (state, response) {
    if (process.env?.VUE_APP_GOOGLE_API_DYNAMIC === 'yes') {
      state.googleMapsApiKey = response?.formbuilder?.googleMapsApiKey || null
    } else {
      state.googleMapsApiKey = null
    }

    if (response?.wacom && Object.keys(response.wacom).length) {
      state.wacom = {
        encryptionPublicKey: response.wacom.encryptionPublicKey,
        sdkLicense: response.wacom.sdkLicense
      }
    }

    if (response.customization?.appLogo1?.path) {
      state.logoImg = process.env.VUE_APP_API_URL_STATIC_ASSETS + response.customization?.appLogo1?.path
      localStorage.setItem('logo_img', state.logoImg)
    }
  },
  coreSettings (state, response) {
    state.appName = response.appName
    if (process?.env?.VUE_APP_LUMBREDOCS_V3) {
      if (typeof response.logoLumbreDocs !== 'undefined') {
        state.logoLumbreDocs = response.logoLumbreDocs
        localStorage.setItem('logo_lumbredocs', state.logoLumbreDocs)
      }
    }
    if (typeof response.logoImg !== 'undefined') {
      state.logoImg = response.logoImg
      localStorage.setItem('logo_img', state.logoImg)
    }
    if (typeof response.collapsedLogoImg !== 'undefined') {
      state.collapsedLogoImg = response.collapsedLogoImg
      localStorage.setItem('collapsed_logo_img', state.collapsedLogoImg)
    }
    if (typeof response.logoHomeImg !== 'undefined') {
      state.logoHomeImg = response.logoHomeImg
      localStorage.setItem('logo_home_img', state.logoHomeImg)
    }
    if (typeof response.favicon !== 'undefined') {
      state.favicon = response.favicon
      faviconElement.href = state.favicon
      localStorage.setItem('favicon', state.favicon)
      state.faviconDot = response.faviconDot
      localStorage.setItem('favicon_dot', state.faviconDot)
    }
    localStorage.setItem('app_name', state.appName)
    if (typeof response.menuBgColor !== 'undefined') {
      state.menuBgColor = response.menuBgColor
    }
    if (typeof response.menuFontColor !== 'undefined') {
      state.menuFontColor = response.menuFontColor
    }
    if (typeof response.menuActiveFontColor !== 'undefined') {
      state.menuActiveFontColor = response.menuActiveFontColor
    }
    if (typeof response.logoAlignItems !== 'undefined') {
      state.logoAlignItems = response.logoAlignItems
    }
    if (typeof response.logoJustifyContent !== 'undefined') {
      state.logoJustifyContent = response.logoJustifyContent
    }
    if (typeof response.logoWidth !== 'undefined') {
      state.logoWidth = response.logoWidth
    }
    if (typeof response.logoPadding !== 'undefined') {
      state.logoPadding = response.logoPadding
    }
    if (typeof response.loginLogoWidth !== 'undefined') {
      state.loginLogoWidth = response.loginLogoWidth
    }
    if (typeof response.loginLogoWidth !== 'undefined') {
      state.loginLogoWidth = response.loginLogoWidth
    }
    if (typeof response.loginLogoJustifyContent !== 'undefined') {
      state.loginLogoJustifyContent = response.loginLogoJustifyContent
    }
    if (typeof response.loginTextAlign !== 'undefined') {
      state.loginTextAlign = response.loginTextAlign
    }
    if (typeof response.customerList !== 'undefined') {
      state.customerList = response.customerList
    }
    if (typeof response.loginH1Text !== 'undefined') {
      state.loginH1Text = response.loginH1Text
    } else {
      state.loginH1Text = '¡Comenzá la transformación digital de tu empresa!'
    }

    document.documentElement.style.setProperty('--app-accent-color', state.menuBgColor)
  },
  homeSettings (state, response) {
    state.title1 = response.title1
    state.title2 = response.title2
    state.text = response.text
    state.bgImage = response.bgImage
    if (typeof response.loginBgColor !== 'undefined') {
      state.loginBgColor = response.loginBgColor
      localStorage.setItem('login_bg_color', state.loginBgColor)
    }

    if (typeof response.logoLumileWhite !== 'undefined') {
      state.logoLumileWhite = response.logoLumileWhite
      localStorage.setItem('logo_lumile_white', state.logoLumileWhite)
    }

    localStorage.setItem('title1', state.title1)
    localStorage.setItem('title2', state.title2)
    localStorage.setItem('text', state.text)
    localStorage.setItem('bg_image', state.bgImage)
  },
  dashSettings (state, response) {
    state.dashItems = response.items[0]
    state.loading = false
  },
  mutateResetDashSettings (state) {
    state.dashItems = []
    state.loading = false
  },
  resetStates (state) {
    state.searchOnFields = []
  },
  mutateLoading (state, loading) {
    state.loading = !!loading
  },
  listSettings (state, response) {
    state.listTitle = response.title
    state.order = response.order
    state.orderBySetting = response.orderBySetting
    state.searchOnFields = response.searchOnFields
    state.perPageSetting = response.perPageSetting
    state.defaultItemsPerPage = response.defaultItemsPerPage
    state.limitExportFromClient = response.limitExportFromClient
    state.showFilterTime = !!response.showFilterTime
    state.showGoBackButton = !!response.showGoBackButton
    state.highlightSearchMatches = !!response.highlightSearchMatches
    state.showPDFButton = !!response.showPDFButton
    state.showLmDropdownTableCustom = response.showLmDropdownTableCustom
    if (typeof response.showCSVButton !== 'undefined') {
      state.showCSVButton = !!response.showCSVButton
    } else {
      state.showCSVButton = true
    }
    state.hideSearchSection = !!response.hideSearchSection
    state.hideBreadcrumb = !!response.hideBreadcrumb

    if (Array.isArray(response.lmListActions)) {
      state.lmListActions = response.lmListActions
    } else {
      state.lmListActions = []
    }

    if (response.createSegment) {
      state.createSegment = response.createSegment
    } else {
      state.createSegment = {}
    }

    if (response.downloadCsvFileName) {
      state.downloadCsvFileName = response.downloadCsvFileName
    }
    state.apiCallPath = response.apiCallPath
    state.highlight = response.highlight
    state.actions = response.actions
  },
  mutateMainMenuSettings (state, response) {
    state.mainMenuItems = response.mainMenuItems
  },
  mutateAppUsageTerms (state, payload) {
    state.appUsageTerms = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
